import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { visibleNotifications } from '../+state/notifications/notifications.selectors';
import { Observable } from 'rxjs';
import { Notification } from '../+state/notifications/models/notification.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { removeAllNotifications, removeNotification } from '../+state/notifications/notifications.actions';

@UntilDestroy()
@Component({
    selector: 'aft-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false,
})
export class NotificationsComponent implements OnInit {
  protected notifications: Notification[];

  private _notifications$: Observable<Notification[]> = this._store.select(visibleNotifications);

  constructor(
    private _store: Store,
  ) {}

  public ngOnInit(): void {
    this._initSubs();
  }

  protected notificationClosed(createdAt: Date): void {
    this._store.dispatch(removeNotification({ createdAt }));
  }

  protected removeAllNotifications(): void {
    this._store.dispatch(removeAllNotifications());
  }

  private _initSubs(): void {
    this._notifications$
      .pipe(
        untilDestroyed(this),
      )
      .subscribe(notifications => {
        this.notifications = notifications;
      });
  }
}
